import React, { useEffect, /*useRef,*/ useState } from 'react'

import { useDataSource } from '../../hooks/source/BaseDataSource'
import { Icon } from '../../ui/icon'
import { classNames } from '../../util/class-names'

import { DropdownItem } from '../dropdown/DropdownItem'
import { DropdownMenu } from '../dropdown/DropdownMenu'

import { useFormGroupContext } from './FormGroup'

import classes from './InputAutocomplete.module.scss'

interface InputAutocompleteProps {
  disabled?: boolean
  onChange?: (_: number | string) => void
  placeholder?: string
  renderItem?: <T>(_: T) => React.ReactElement
  type?: 'email' | 'text'
  value?: string
}

const clickEvent = new Set<(event: MouseEvent) => void>()
const escEvent = new Set<() => void>()

window.addEventListener('click', event => {
  clickEvent.forEach(callback => callback(event))
})

window.addEventListener('keyup', event => {
  if (event.key === 'Escape') {
    escEvent.forEach(callback => callback())
  }
})

export const InputAutocomplete: React.FC<InputAutocompleteProps> = ({ onChange, renderItem, ...props }) => {
  const [opened, setOpened] = useState(false)
  const [selected, setSelected] = useState('')
  const [value, setValue] = useState('')
  const dataSource = useDataSource()
  const formGroup = useFormGroupContext()
  const params = {
    className: classNames('form-control', classes.input),
    id: formGroup?.id,
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => {
      dataSource.onChange(event.target.value)
      setSelected('')
      setValue(event.target.value)
    },
    onFocus: () => setOpened(true),
    value: selected || value
  }
  const handleBackdrop = () => setOpened(false)
  const handleClear = () => {
    dataSource.onChange('')
    onChange?.('')
    setOpened(false)
    setSelected('')
    setValue('')
  }
  const handleClick = (key: number | string, value: string) => () => {
    onChange?.(key)
    setOpened(false)
    setSelected(value)
    setValue(value)
  }
  useEffect(() => {
    const handleEscape = () => setOpened(false)
    escEvent.add(handleEscape)
    return () => {
      escEvent.delete(handleEscape)
    }
  }, [])
  useEffect(() => {
    if (props.disabled !== true) {
      dataSource.onChange(value)
    }
  }, [props.disabled])
  return (
    <div className={classes.autocomplete}>
      <div className={classNames(classes.backdrop, opened && classes.visible)} onClick={handleBackdrop} />
      <div className={classes.input}>
        <input {...params} {...props} />
        <button className={classNames(classes.clear, value && classes.visible)} onClick={handleClear} type="button">
          <Icon.Times />
        </button>
      </div>
      <DropdownMenu className={classes.menu} opened={opened}>
        {dataSource.items ? (
          dataSource.items.length ? (
            dataSource.items.map(([key, value]) => (
              <DropdownItem key={key} onClick={handleClick(key, `${value}`)}>
                {renderItem?.(value) || value}
              </DropdownItem>
            ))
          ) : (
            <div>Nenhum resultado encontrado.</div>
          )
        ) : (
          <div className={classes.loader}>
            <Icon.CircleNotch spin />
          </div>
        )}
      </DropdownMenu>
    </div>
  )
}
